module.exports = __webpack_public_path__ + "assets/img/78fe-de.svg";